// Components
import UpdatePasswordView from "../../components/updatePassword";

const UpdatePassword = () => <UpdatePasswordView />;

export default UpdatePassword;
